"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var _kernel_store_types_1 = require("../../types");
var generation_1 = require("../../selectors/generation");
var generation_2 = require("../../stores/generation");
var updatePlaylist_1 = __importDefault(require("../playback/updatePlaylist"));
var player_1 = require("../../selectors/player");
var lockPlaylistUpdateState_1 = __importDefault(require("../playback/lockPlaylistUpdateState"));
function addGenerationRotations(rotations, switchImmediately) {
    var action = function (dispatch, getState) {
        var localRotationId = (0, generation_1.selectLastLocalRotationId)(getState());
        var currentStreamId = (0, generation_1.selectCurrentStreamId)(getState());
        var rotationsWithIds = rotations
            .map(function (rotation) {
            return __assign(__assign({}, rotation), { id: localRotationId++ });
        })
            .map(function (rotation) { return (__assign(__assign({}, rotation), { rotationId: rotation.id, streamId: rotation.type === 0 ? currentStreamId !== null && currentStreamId !== void 0 ? currentStreamId : rotation.streamId : rotation.streamId })); });
        dispatch((0, generation_2.setGenerationMetadata)({
            lastLocalRotationId: localRotationId,
        }));
        if ((0, player_1.selectCurrentPlayState)(getState()) !== _kernel_store_types_1.EPlayState.PLAY) {
            dispatch((0, lockPlaylistUpdateState_1.default)(true));
        }
        dispatch((0, updatePlaylist_1.default)(rotationsWithIds, switchImmediately));
    };
    action.type = addGenerationRotations.type;
    return action;
}
addGenerationRotations.type = "addGenerationRotations";
exports.default = addGenerationRotations;
//# sourceMappingURL=addGenerationRotations.js.map